import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

// ✅ Customer List Thunk
export const get_customer_list = createAsyncThunk("customers", async (data) => {
  const body = new FormData();
  body.append("userid", 1);
  body.append("ingress", 1);
  body.append("page", data.page);
  body.append("limit", data.rows);
  const response = await fetch(baseUrl + "customer-list.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  return res;
});

// ✅ Get All Customer List Thunk
export const get_all_customer_list = createAsyncThunk(
  "all_customers",
  async (data) => {
    const body = new FormData();
    body.append("userid", 1);
    body.append("ingress", 1);
    body.append("page", 1);
    body.append("limit", 10000);
    const response = await fetch(baseUrl + "customer-list.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    return res;
  }
);

// ✅ FIXED: Fetch Customer Details Thunk
export const fetchSecurityDepositDetails = createAsyncThunk(
  "customers/fetchDetails",
  async (data) => {
    const body = new FormData();
    body.append("userid", data.userid);
    body.append("ingress", 4);
    body.append("id", data.id);
    
    const response = await fetch(baseUrl + "customer-details.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    return res;
  }
);

const initialState = {
  customer_list: [],
  loading: false,
  all_customer_list: [],
  all_loading: false,
  total_customer_count: 0,
  customerDetails: null,
  detailsLoading: false,
  detailsError: null,
};

const customerSlice = createSlice({
  name: "customers",
  initialState,
  extraReducers: (builder) => {
    // ✅ Get Customer List Cases
    builder.addCase(get_customer_list.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(get_customer_list.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(get_customer_list.fulfilled, (state, action) => {
      state.loading = false;
      const data = action.payload;
      if (data.success) {
        state.total_customer_count = data.totalcount;
        state.customer_list = data.reponselist;
      } else {
        state.customer_list = [];
      }
    });

    // ✅ Get All Customer List Cases
    builder.addCase(get_all_customer_list.pending, (state, action) => {
      state.all_loading = true;
    });
    builder.addCase(get_all_customer_list.rejected, (state, action) => {
      state.all_loading = false;
    });
    builder.addCase(get_all_customer_list.fulfilled, (state, action) => {
      state.all_loading = false;
      const data = action.payload;  
      if (data.success) {
        state.all_customer_list = data.reponselist;
      } else {
        state.all_customer_list = [];
      }
    });

    // ✅ FIXED: Fetch Customer Details Cases
    builder.addCase(fetchSecurityDepositDetails.pending, (state) => {
      state.detailsLoading = true;
      state.detailsError = null;
    });
    builder.addCase(fetchSecurityDepositDetails.fulfilled, (state, action) => {
      state.detailsLoading = false;
      state.customerDetails = action.payload;
      state.detailsError = null;
    });
    builder.addCase(fetchSecurityDepositDetails.rejected, (state, action) => {
      state.detailsLoading = false;
      state.detailsError = action.error.message;
      state.customerDetails = null;
    });
  },
});

export default customerSlice.reducer;